import Lottie from "lottie-web";
import gsap from "gsap";

export default class Animations {
    constructor() {
        this.init();
    }

    init() {
        if ($('#introduction-logo-animation').length) {
            $('body').addClass('show');
            Lottie.loadAnimation({
                container: document.getElementById('introduction-logo-animation'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: ANIMATIONS_PATH + '/introduction.json'
            });

            Lottie.loadAnimation({
                container: document.getElementById('introduction-logo-animation-negative'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: ANIMATIONS_PATH + '/introduction.json'
            });

            let anim = Lottie.loadAnimation({
                container: document.getElementById('hand-click'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: ANIMATIONS_PATH + '/hand-click.json'
            });

            anim.addEventListener('complete', function () {
                $('#hand-click').addClass('d-none');
                setTimeout(function () {
                    $('#hand-click').removeClass('d-none');
                    anim.goToAndPlay(0);
                }, 2000);
            })

            this.getContent();

            setTimeout(() => {
                $('.to-remove').addClass('white');
                $('.mask-container').addClass('show');
                $('#intro-animation-cape').addClass('show');
            }, 3000)

            setTimeout(() => {
                $('#introduction-logo-animation-negative').removeClass('fill-white');
                this.animate();
                this.manageTransition();
            }, 4200)
        }

        if ($('#logo-animation').length) {
            let lottieLogo = Lottie.loadAnimation({
                container: document.getElementById('logo-animation'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: ANIMATIONS_PATH + '/logo.json'
            });
        }

        if ($('#loader-cape').length) {
            let lottieLoader = Lottie.loadAnimation({
                container: document.getElementById('loader-cape'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: ANIMATIONS_PATH + '/loader.json'
            });
        }
    }

    animate() {
        let $container = document.getElementById('intro-animation-cape');
        if (!$container) return;

        this.oldx = window.innerWidth / 2;
        this.oldy = window.innerHeight / 2;

        this.clipPosition = null;
        this.logoPosition = null;
        this.lettersCPosition = null;
        this.lettersAPosition = null;
        this.lettersPPosition = null;
        this.lettersEPosition = null;


        this.cDuration = 1;
        this.aDuration = 5;
        this.pDuration = 7;
        this.eDuration = 4;

        this.onMouseMove(this.oldx, this.oldy, 0, 0, true);

        $container.addEventListener('mousemove', (e) => {
            if (this.timeoutOnAnimate !== undefined) {
                window.cancelAnimationFrame(this.timeoutOnAnimate);
            }

            this.timeoutOnAnimate = window.requestAnimationFrame(() => {
                this.onMouseMove(e.pageX, e.pageY, e.movementX, e.movementY);
            });
        });
    }

    onMouseMove(pageX, pageY, translateX, translateY, initial = false) {

        if (this.clipPosition !== null) {
            this.clipPosition.kill();
            this.logoPosition.kill();

            if (this.lettersCPosition !== null) {
                this.lettersCPosition.kill();
                this.lettersAPosition.kill();
                this.lettersPPosition.kill();
                this.lettersEPosition.kill();
            }
        }

        this.clipPosition = gsap.to(document.documentElement, {
            "--clip-position-x": pageX + "px",
            "--clip-position-y": pageY + "px",
            duration: initial ? 0 : 0.5
        });

        this.logoPosition = gsap.to(document.documentElement, {
            "--logo-position-x": pageX + "px",
            "--logo-position-y": pageY + "px",
            duration: initial ? 0 : 1
        });

        if (translateX) {
            this.lettersCPosition = gsap.to(document.documentElement, {
                "--logo-c-position-x": translateX + "px",
                "--logo-c-position-y": translateY + "px",
                duration: initial ? 0 : this.cDuration
            });

            this.lettersAPosition = gsap.to(document.documentElement, {
                "--logo-a-position-x": translateX + "px",
                "--logo-a-position-y": translateY + "px",
                duration: initial ? 0 : this.aDuration
            });

            this.lettersPPosition = gsap.to(document.documentElement, {
                "--logo-p-position-x": translateX + "px",
                "--logo-p-position-y": translateY + "px",
                duration: initial ? 0 : this.pDuration
            });

            this.lettersEPosition = gsap.to(document.documentElement, {
                "--logo-e-position-x": translateX + "px",
                "--logo-e-position-y": translateY + "px",
                duration: initial ? 0 : this.eDuration
            });
        }

        if(!initial && !$('#intro-animation-cape').hasClass('moved')) {
            $('#intro-animation-cape').addClass('moved');
        }
    }

    getContent() {
        this.htmlData = '';
        this.homeData = null;

        $.ajax({
            url: "/?forceHome=true",
            type: 'GET',
            dataType: 'html',
            success: (data) => {
                this.htmlData = data.replace(/^.*?<body.*?>(.*?)<\/body>.*?$/s, "$1");
                this.homeData = data;
            }
        });

    }

    manageTransition() {
        $('#intro-animation-cape').off('click').on('click', (event) => {
            if(!$('.bg-right-left').hasClass('show')) {
                event.preventDefault();
                $('.bg-right-left').addClass('show');
                $(event.currentTarget).before(this.htmlData);
                $('.to-remove').removeClass('show');
                $(event.currentTarget).addClass('clicked_1');
                $('.bg-right-left-container').addClass('transparent');


                setTimeout(() => {
                    $(event.currentTarget).addClass('clicked');
                }, 700)

                if (this.homeData !== null) {
                    window.history.pushState({"html": this.homeData.html, "pageTitle": this.homeData.pageTitle}, "", '/');
                }

                setTimeout(() => {
                    $('#intro-animation-cape').css('cursor', 'default');
                    $('#intro-animation-cape').remove();
                    $('.to-remove').remove();
                }, 3800)
            }
        });
    }

}

